import React, { useContext, useEffect, useState } from 'react';
import {
  Edit,
  Add,
  Upload,
  Close,
  Visibility,
  QueryStats,
} from '@mui/icons-material';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { DocumentosContext } from 'contexts/DocumentosContext';
import { DropsContext } from 'contexts/DropsContext';
import { AuthContext } from 'contexts/AuthContext';
import { Grid, IconButton, Typography, Box } from '@mui/material';
import { dropTipoServico } from 'utils/drops';
import { findOnArray } from 'utils/functions';
import { useDialog, useModal } from 'components/Modals';
import EntidadeModal from 'components/Modals/EntidadeModal';
import EquipamentoModal from 'components/Modals/EquipamentoModal';
import FullEquipamentoModal from 'components/Modals/FullEquipamentoModal';
import PesquisaEquipamentoModal from 'components/Modals/PesquisaEquipamentoModal';
import VirtualDrop from 'components/VirtualDrop';
import Container from 'components/Container';
import InputMask from 'components/InputMask';
import Dropdown from 'components/Dropdown';
import Button from 'components/Button';
import Header from 'components/Header';
import Input from 'components/Input';
import Card from 'components/Card';
import moment from 'moment';

const Equipamento = () => {
  const titulo = 'Ordem de Serviço';
  const defaultValues = {
    cadastro_id: null,
    tecnico_id: null,
    tipo: 'CORRETIVA',
    sn: '',
    equipamento: null,
    relato: '',
    acessorios: '',
    servico_id: null,
    servico_descricao: '',
    servico_valor: '',
  };
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const { openDialog } = useDialog();
  const { openModal, closeModal } = useModal();
  const { control, handleSubmit, watch, setValue } = useForm({ defaultValues });
  const { postLoading, postDocumento, postDocumentoMidia } =
    useContext(DocumentosContext);
  const { drops } = useContext(DropsContext);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (!Boolean(watch('servico_id'))) {
      setValue('servico_id', drops?.ProdutoServico?.[0]?.value || null);
    }
    setValue(
      'servico_descricao',
      drops?.ProdutoServico?.[0]?.label || 'Manutenção'
    );
  }, [drops?.ProdutoServico]);

  const onSubmit = (values) => {
    let Itens = [];
    if (Boolean(values?.servico_id) || Boolean(values?.servico_descricao)) {
      Itens?.unshift({
        produto_id: values?.servico_id,
        descricao: values?.servico_descricao,
        quantidade: 1,
        preco: values?.servico_valor,
        Processos: [
          {
            operacao: 10,
            descricao: values?.servico_descricao,
            apontamento: 'SIM',
          },
        ],
      });
    }
    const data = {
      Documento: {
        especie_id: 16,
        natureza_operacao_id: 11,
        filial_id: user?.filial_id,
        cadastro_id: values?.cadastro_id,
        dtemissao: moment().format('YYYY-MM-DD HH:mm:ss'),
        users_id: user?.id,
      },
      Servico: {
        tipo: values?.tipo,
        tecnico_id: values?.tecnico_id,
        relatocli: values?.relato,
        acessorios: values?.acessorios,
      },
      Equipamentos: [
        {
          equipamento_id: values?.equipamento,
          sn: values?.sn,
        },
      ],
      Itens: Itens?.map((i, index) => ({ ...i, sequencia: index + 1 })),
      Registros: [
        {
          users_id: user?.id,
          datahora: moment().format('YYYY-MM-DD HH:mm:ss'),
          status_id: Boolean(values?.tecnico_id) ? 45 : 16,
        },
      ],
    };
    if (Boolean(file)) {
      const formData = new FormData();
      formData.append('documento', JSON.stringify(data));
      formData.append('midia', file);
      postDocumentoMidia({ data: formData, cb: () => navigate(-1) });
    } else {
      postDocumento({ data, cb: () => navigate(-1) });
    }
  };

  const onSearchEquipamento = (values) => {
    setValue('sn', values?.sn);
    setValue('equipamento', values?.equipamento_id);
    closeModal();
  };

  return (
    <Container>
      <Header titulo={titulo} />
      <Card>
        <Grid container spacing={2}>
          <Grid item xs={12} display="flex" alignItems="center">
            <Box flex={1}>
              <VirtualDrop
                name="cadastro_id"
                control={control}
                label="Entidade"
                options={drops?.Entidade}
                refresh="Entidade"
              />
            </Box>
            <IconButton
              color="primary"
              size="small"
              onClick={() =>
                window.open(
                  `https://cadastros.eprom.com.br/app/Entidades/Detalhes/${watch(
                    'cadastro_id'
                  )}`
                )
              }
              disabled={!Boolean(watch('cadastro_id'))}
            >
              <Visibility fontSize="small" />
            </IconButton>
            <IconButton
              color="primary"
              size="small"
              onClick={() =>
                window.open(
                  `https://cadastros.eprom.com.br/app/Entidades/Indicadores/${watch(
                    'cadastro_id'
                  )}`
                )
              }
              disabled={!Boolean(watch('cadastro_id'))}
            >
              <QueryStats fontSize="small" />
            </IconButton>
            <IconButton
              color="primary"
              size="small"
              disabled={!Boolean(watch('cadastro_id'))}
              onClick={() =>
                openDialog(
                  <EntidadeModal
                    entidade_id={watch('cadastro_id')}
                    callback={(id) => setValue('cadastro_id', id)}
                  />,
                  'Editar Entidade'
                )
              }
            >
              <Edit fontSize="small" />
            </IconButton>
            <IconButton
              color="primary"
              size="small"
              onClick={() =>
                openDialog(
                  <EntidadeModal
                    callback={(id) => setValue('cadastro_id', id)}
                  />,
                  'Cadastrar Entidade'
                )
              }
            >
              <Add fontSize="small" />
            </IconButton>
          </Grid>
          <Grid item xs={12}>
            <Dropdown
              name="tecnico_id"
              control={control}
              label="Técnico"
              options={drops?.Users?.filter((f) => f?.nivel === 'TÉCNICO')}
            />
          </Grid>
          <Grid item xs={12}>
            <Dropdown
              name="tipo"
              control={control}
              label="Tipo do Serviço"
              options={dropTipoServico}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Input
              name="relato"
              control={control}
              label="Relato do Cliente"
              multiline
              rows={3}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Input
              name="acessorios"
              control={control}
              label="Acessórios"
              multiline
              rows={3}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" component="div" align="center">
              Informações do Serviço
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Dropdown
              name="servico_id"
              control={control}
              label="Serviço"
              options={drops?.ProdutoServico}
              onValueChange={(v) =>
                setValue('servico_descricao', v?.label || '')
              }
            />
          </Grid>
          <Grid item xs={12} sm={8}>
            <Input
              name="servico_descricao"
              control={control}
              label="Descrição"
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <InputMask name="servico_valor" control={control} label="Valor" />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h6" component="div" align="center">
              Dados do Equipamento
            </Typography>
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="outlined"
              color="primary"
              onClick={() =>
                openModal(
                  <PesquisaEquipamentoModal onSubmit={onSearchEquipamento} />,
                  90
                )
              }
            >
              Pesquisar Equipamento
            </Button>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Input name="sn" control={control} label="Serial Number" />
          </Grid>
          <Grid item xs={10} sm={8} display="flex" alignItems="center">
            <Box flex={1}>
              <VirtualDrop
                name="equipamento"
                control={control}
                label="Equipamento"
                options={drops?.Equipamento}
              />
            </Box>
            <IconButton
              color="primary"
              disabled={!Boolean(watch('equipamento'))}
              onClick={() =>
                openDialog(
                  <EquipamentoModal
                    equipamento={findOnArray(
                      watch('equipamento'),
                      drops?.Equipamento
                    )}
                    callback={(id) => setValue('equipamento', id)}
                  />,
                  'Editar Equipamento'
                )
              }
            >
              <Edit />
            </IconButton>
            <IconButton
              color="primary"
              onClick={() =>
                openDialog(
                  <FullEquipamentoModal
                    callback={(id) => setValue('equipamento', id)}
                  />,
                  'Cadastrar Equipamento'
                )
              }
            >
              <Add />
            </IconButton>
          </Grid>
          <Grid item xs={12} display="flex" alignItems="center">
            <Button
              variant="outlined"
              color="primary"
              startIcon={<Upload />}
              onClick={() => document.getElementById('upload-midia')?.click()}
            >
              <input
                id="upload-midia"
                hidden
                accept="image/*"
                type="file"
                onChange={({ target }) => {
                  setFile(target.files[0] || null);
                  target.value = '';
                }}
              />
              Upload
            </Button>
            {Boolean(file) && (
              <Typography
                variant="body2"
                sx={{ marginLeft: 1, color: 'primary.main' }}
              >
                {file?.name}
              </Typography>
            )}
            {Boolean(file) && (
              <IconButton onClick={() => setFile(null)} size="small">
                <Close />
              </IconButton>
            )}
          </Grid>
          <Grid item xs={12} textAlign="center">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit(onSubmit)}
              loading={postLoading}
            >
              Finalizar
            </Button>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
};

export default Equipamento;
